function getMainSectionId() {
  const mainSectionEl = document.querySelector('[id^="shopify-section-template--"][id$="__main"]');
  if (!mainSectionEl) {
    console.warn("⚠️ Main Shopify section not found.");
    return null;
  }
  const sectionId = mainSectionEl.id.replace("shopify-section-", "");
  console.log("✅ Found main section:", sectionId);
  return sectionId;
}

async function replaceProductMedia(subProductHandle, variantId) {
  const sectionId = getMainSectionId();
  if (!sectionId) return;

  const url = `/products/${subProductHandle}?sections=${sectionId}&variant=${variantId}`;

  try {
    const response = await fetch(url);
    const data = await response.json();
    const newSectionHTML = data[sectionId];

    const parser = new DOMParser();
    const doc = parser.parseFromString(newSectionHTML, "text/html");

    const newMediaDiv = doc.querySelector(".product-information__media");
    const oldMediaDiv = document.querySelector(".product-information__media");

    if (newMediaDiv && oldMediaDiv) {
      oldMediaDiv.replaceWith(newMediaDiv);
      console.log("✅ Product media updated successfully");
    } else {
      console.warn("⚠️ Could not find product-information__media div in the new or existing section");
    }

    // 2️⃣ Replace zoom dialog (if it exists)
    const newZoomDialog = doc.querySelector('[id^="zoom-dialog-"][id$="__media-gallery"]');
    const oldZoomDialog = document.querySelector('[id^="zoom-dialog-"][id$="__media-gallery"]');

    if (newZoomDialog && oldZoomDialog) {
        oldZoomDialog.replaceWith(newZoomDialog);
        console.log("✅ Zoom dialog updated successfully");
    } else {
        console.warn("⚠️ Could not find zoom dialog in new or existing section");
    }
  } catch (error) {
    console.error("❌ Error fetching product media section:", error);
  }
}

async function fetchVariantMedia(subProductHandle, variantId, sectionId) {
  const url = `/products/${subProductHandle}?sections=${sectionId}&variant=${variantId}`;
  const response = await fetch(url);
  const data = await response.json();
  const newSectionHTML = data[sectionId];

  const parser = new DOMParser();
  const doc = parser.parseFromString(newSectionHTML, "text/html");
  return doc.querySelector(".product-information__media");
}

async function replaceProductMediaForVariants(variants) {
  const sectionId = getMainSectionId();
  if (!sectionId) return;

  const oldMediaDiv = document.querySelector(".product-information__media");
  if (!oldMediaDiv) return console.warn("⚠️ No media div found in current section");

  // Create a temporary container
  const combinedMedia = document.createElement("div");
  combinedMedia.classList.add("product-information__media");

  for (const { subProductHandle, variantId } of variants) {
    const mediaDiv = await fetchVariantMedia(subProductHandle, variantId, sectionId);
    if (mediaDiv) {
      // Append each product’s media to the combined container
      combinedMedia.innerHTML += mediaDiv.innerHTML;
    }
  }

  // Replace old media section with combined version
  oldMediaDiv.replaceWith(combinedMedia);
  console.log("✅ Combined product media updated successfully");
}

document.addEventListener("DOMContentLoaded", () => {
  window.addEventListener("variant-media:update", async (event) => {
    const { variants, subProductHandle, variantId } = event.detail || {};

    if (variants && Array.isArray(variants) && variants.length > 0) {
      await replaceProductMediaForVariants(variants);
    } else if (subProductHandle && variantId) {
      // fallback for single variant
      await replaceProductMedia(subProductHandle, variantId);
    }
  });
});